module.exports = [{"value":1,"text":"เข็มหนึ่ง"},{"value":2,"text":"เข็มสอง"},{"value":3,"text":"เข็มสาม"},{"value":4,"text":"เข็มสี่"},{"value":5,"text":"เข็มห้า"},{"value":6,"text":"เข็มหก"},{"value":7,"text":"เข็มเจ็ด"},{"value":8,"text":"เข็มแปด"},{"value":9,"text":"เข็มเก้า"},{"value":10,"text":"เข็มสิบ"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/vaccine/vaccineDosesName.json
// module id = OoOr
// module chunks = 2